<template>
    <card>
      <slot slot="header">
        <v-toolbar-title>
          <v-icon>vpn_key</v-icon>
          Redefinir senha
        </v-toolbar-title>
      </slot>

      <slot slot="body">
        <v-form>
          <v-container grid-list-lg fluid>
            <v-layout row justify-center align-center wrap>
              <v-flex xs12>
                <v-text-field required prepend-icon="lock" name="password" label="Senha" id="password"
                              type="password" v-model="user.password"
                              :error-messages="errors.collect('password')"
                              v-validate="'required|min:6'"
                              data-vv-as="Senha"
                              required/>
              </v-flex>
              <v-flex xs12>
                <v-text-field prepend-icon="check" name="confirmation" label="Confirmação" id="confirmation"
                              type="password" v-model="user.confirmation"
                              :error-messages="errors.collect('confirmation')"
                              v-validate="'required|confirmed:password|min:6'"
                              data-vv-as="Confirmação"
                              required/>
              </v-flex>
              <v-flex xs12 class="text-xs-center">
                <v-btn dark class="gradient mx-auto" @click="reset">
                  Redefinir
                </v-btn>
                <v-btn flat href="#/">Voltar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </slot>
    </card>
</template>

<style scoped>
  .gradient {
    background: linear-gradient(40deg, #4a97ce, #5fbf8d);
  }
</style>

<script>
  import Card from '../shared/Card'

  export default {
    components: {Card},
    data () {
      return {
        user: {
          password: '',
          confirmation: '',
          token: this.$route.params.token
        }
      }
    },
    methods: {
      reset () {
        this.$http.post('auth/reset-password/', this.user)
          .then(() => {
          }, (res) => {
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/Reset.vue